import { Component, Inject, Injectable, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/services/auth.service';
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
    selector: 'app-add-connection-dialog',
    templateUrl: './add-connection-dialog.component.html',
    styleUrls: ['./add-connection-dialog.component.css'],
    standalone: false
})
export class AddConnectionDialogComponent {
  searchForm: FormGroup;
  selectedCategories: string[] = [];
  care_team_list: any;
  searchText: any = '';
  filteredList: any[] = [];
  selectedCategoryTitle: any;

  constructor(
    private fb: FormBuilder, private authService: AuthService, private router: Router, public send_menu_request_dialog: MatDialog,
    private dialogRef: MatDialogRef<AddConnectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.searchForm = this.fb.group({
      categories: ['', Validators.required],
      searchQuery: ['']
    });
  }

  ngOnInit() {
    // console.log('data',this.data)
    this.selectedCategoryTitle = localStorage.getItem('selectedCategory')
    if (this.selectedCategoryTitle !== 'Personal') {
      this.selectedCategoryTitle = 'Personal'; // fallback to Personal
    }
    //console.log('selectedCategoryTitle',this.selectedCategoryTitle)
    
    this.authService.care_team_list_all().subscribe((res: any) => {
      this.care_team_list = res.consumers;
      this.filteredList = [...this.care_team_list]; // initialize
    })

    // Set the default selected category
    if (this.data.defaultCategory) {
      this.searchForm.get('categories')?.setValue([this.data.defaultCategory]);
      this.selectedCategories = [this.data.defaultCategory];
      //console.log('..selectedCategories',this.selectedCategories)
    }

    this.searchForm.get('searchQuery')?.valueChanges.subscribe(value => {
      this.searchText = value;
      this.onSearch();
    });
  }

  openSendRequestDialog(value: any) {
    this.send_menu_request_dialog.open(SendCareRequest, {
      data: value
    })
    this.onCancel();
  }

  onCategoryChange(event: any) {
    this.selectedCategories = event.value;
  }

  // onSearch() {
  //   const query = this.searchText.toLowerCase();

  //   this.filteredList = this.care_team_list.filter((item: any) =>
  //     item.firstName?.toLowerCase().includes(query) ||
  //     item.lastName?.toLowerCase().includes(query) ||
  //     item.email?.toLowerCase().includes(query)
  //   );
  // }
  onSearch() {
    const query = this.searchForm.get('searchQuery')?.value?.toLowerCase().trim() || '';
    if (!query) {
      this.filteredList = this.care_team_list;
      return;
    }

    this.filteredList = this.care_team_list.filter((item: any) => {
      const fullName = `${item.firstName || ''} ${item.lastName || ''}`.toLowerCase().trim();
      return (
        fullName.includes(query) ||
        item.firstName?.toLowerCase().includes(query) ||
        item.lastName?.toLowerCase().includes(query)
      );
    });
  }


  sendRequest(connection: any) {
    this.dialogRef.close({
      ...connection,
      categories: this.selectedCategories
    });
  }

  onCancel() {
    this.dialogRef.close();
  }
  capitalizeFirstLetter(status: string): string {
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
  }
}


@Component({
    selector: 'send-care-request',
    templateUrl: 'send-care-request.html',
    styleUrls: ['./add-connection-dialog.component.css'],
    standalone: false
})

@Injectable()
export class SendCareRequest {
  name = new FormControl('');
  selected_entity: any;
  selectedName = '';
  @Input() selectedCategories: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private router: Router, private dialog: MatDialogRef<SendCareRequest>, private authservice: AuthService, private formBuilder: FormBuilder, private toastr: ToastrService) {
    this.selected_entity = data;
  }

  myForm = this.formBuilder.group({
    desc: ['Please accept the request']
  })

  get f() { return this.myForm.controls; }

  ngOnInit() {
    //console.log('val',this.data)
  }


  cancel() {
    this.dialog.close();
  }

  // confirm(desc: any) {
  //   console.log('des',desc)
  //   console.log('selected_entity',this.selected_entity)
  //   let id = this.selected_entity.id;

  //   this.authservice.care_team_send_request(desc, id).subscribe((res: any) => {
  //     if (res.error === true) {
  //       this.toastr.error(res.msg);
  //       this.dialog.close();
  //     } 
  //     else{
  //       this.toastr.success(res.msg || "Relationship Request was sent successfully");
  //       this.dialog.close();
  //     }
  //     // else if (res.msg.description) {
  //     //   this.toastr.info(res.msg.description);
  //     // }
  //   });
  // }

  confirm(desc: any) {
    const id = this.selected_entity.id;

    this.authservice.care_team_send_request(desc, id).subscribe({
      next: (res: any) => {
        // Only handles HTTP 2xx responses
        if (res.error === true) {
          this.toastr.error(res.msg || 'Something went wrong.');
        } else {
          this.toastr.success(res.msg || 'Relationship request sent successfully.');
        }
        this.dialog.close();
      },
      error: (err) => {
        // Handles HTTP 4xx and 5xx
        const serverMsg = err?.error?.msg || 'Something went wrong.';

        // Check status code and show specific message
        switch (err.status) {
          case 400:
            this.toastr.error(serverMsg); // "Relationship already exists."
            break;
          case 401:
            this.toastr.error('Unauthorized access.');
            break;
          case 500:
            this.toastr.error('Server error. Try again later.');
            break;
          default:
            this.toastr.error(serverMsg);
        }

        this.dialog.close();
      }
    });
    this.refreshRoute();
  }

  refreshRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }
  
  capitalizeFirstLetter(status: string): string {
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
  }

}

